// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/arrow-left-start-on-rectangle.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'arrow-left-start-on-rectangle',
  version: 'outline',
  paths: [
    {
      d: 'M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15',
    },
  ],
}
